/* src/app/pages/solicitudes/versolicitud/versolicitud.component.scss */
/*# sourceMappingURL=versolicitud.component.css.map */
